// extracted by mini-css-extract-plugin
export default {"Container":"Subscription_Container__Wyz5S","StatisticsContainer":"Subscription_StatisticsContainer__KtJpS"};